export async function getUserStats(service) {
  try {
    const response = await service.get("/org/users_stats");
    return response;
  } catch (error) {
    console.error("Error fetching user stats:", error);
    throw error;
  }
}

const getUserListV2 = async (
  service,
  isGroupAdminMode,
  currentUserId,
  currentGroupId,
) => {
  const users = await service.get(
    isGroupAdminMode
      ? `/v2/org/users?groupId=${currentGroupId}`
      : "/v2/org/users",
  );

  const mappedUsers = users.map((user) => {
    // Treat org-level and group-level roles as admins.
    const isAdmin =
      user.user_highest_role === "org" || user.user_highest_role === "group";

    // Revert: do NOT derive internal/external directly from who pays.
    // Instead, rely on the is_solo flag provided by the backend for non-admins.
    // is_solo === true  -> External
    // is_solo === false -> Internal
    const isExternal = !isAdmin && user.is_solo;

    const display_user_type = isAdmin
      ? "Admin"
      : isExternal
        ? "External"
        : "Internal";

    return {
      userId: user.user_id,
      user_id: user.user_id,
      full_name: user.full_name,
      first_name: user.first_name,
      last_name: user.last_name,
      birth_date: user.birth_date,
      gender: user.gender,
      email: user.email,
      last_activity_date: user.last_activity_date,
      last_activity_type: user.last_activity_type,
      user_type: user.user_highest_role,
      date_added: user.created_at,
      subscription_payer: user.subscription_payer,
      is_solo: user.is_solo,
      display_user_type,
      action: getActionV2(user, currentUserId),
      hidden: isExternal,
      // Additional computed fields
      isAdmin,
      adminText: isAdmin ? "Admin" : "",
      isExternal: isExternal ? "Yes" : "",
      externalText: isExternal ? "External" : "",
    };
  });

  return { mappedUsers };
};

const getActionV2 = (row, currentUserId) => {
  const isDisabled = row.user_id === currentUserId;
  if (row.subscription_payer === "User") {
    return {
      tooltip: isDisabled ? "" : "Remove",
      icon: "close",
      key: "delete",
      disabled: isDisabled,
      iconProps: {
        color: isDisabled ? "disabled" : "error",
        fontSize: "small",
      },
    };
  } else {
    return {
      tooltip: isDisabled ? "" : "Delete",
      icon: "delete",
      key: "delete",
      disabled: isDisabled,
      iconProps: {
        color: isDisabled ? "disabled" : "error",
        fontSize: "small",
      },
    };
  }
};

export async function getOrgInvoices(service) {
  try {
    const response = await service.get("/org/invoices/list");

    const formattedInvoices = response.map((invoice) => ({
      id: invoice.id,
      invoice_number: invoice.stripe_invoice_number,
      amount_due: invoice.amount_due,
      status: invoice.invoice_status,
      payment_status: invoice.payment_status,
      invoice_url: invoice.invoice_url,
      pdf_url: invoice.hosted_invoice_pdf,
      billing_email: invoice.billing_email,
      billing_period_start: invoice.billing_period_start,
      billing_period_end: invoice.billing_period_end,
      due_date: invoice.due_date,
      paid_at: invoice.paid_at,
      created_at: invoice.created_at,
      org_name: invoice?.org_name,
      org_id: invoice?.org_id,
    }));

    return formattedInvoices;
  } catch (error) {
    console.error("Error fetching invoice list:", error);
    throw error;
  }
}

export async function changeUserPayer(service, userId) {
  try {
    const response = await service.put("/org/users/change_payer", {
      user_id: userId,
    });
    console.log("Payer changed successfully:", response);
    return response;
  } catch (error) {
    console.error("Error changing payer:", error);
    throw error;
  }
}

export { getUserListV2 };
